import React from 'react'
import { FileText } from 'lucide-react'
import styles from './EmptyFeed.module.scss'

interface EmptyFeedProps {
  message?: string
}

export const EmptyFeed: React.FC<EmptyFeedProps> = ({
  message = 'Nessun articolo pubblicato ancora.',
}) => (
  <div className={styles.empty}>
    <FileText size={48} className={styles.icon} />
    <p className={styles.message}>{message}</p>
  </div>
)
